// src/domains/user/user.api.ts

import { useApiQuery } from '@/shared/hooks/useApiQuery';
import { API_ENDPOINTS, getFullEndpoint } from '@/services/api/endpoints';
import { IUserProfile, UserCustomersResponse } from './user.types';

type ApiOptions = {
  enabled?: boolean;
};

export const useUserProfileApi = (options?: ApiOptions) => {
  return useApiQuery<IUserProfile, void>(
    ['userProfile'],
    getFullEndpoint('user', API_ENDPOINTS.USER_PROFILE),
    'get',
    undefined,
    true,
    undefined,
    { enabled: options?.enabled },
  );
};

export const useUserCustomersApi = (options?: ApiOptions) => {
  return useApiQuery<UserCustomersResponse, void>(
    ['userCustomers'],
    getFullEndpoint('user', API_ENDPOINTS.USER_CUSTOMERS),
    'get',
    undefined,
    true,
    undefined,
    { enabled: options?.enabled },
  );
};
